import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const setOwner = createAsyncThunk(
  "setOwner",
  async (owner, { rejectWithValue, fulfillWithValue }) => {
    return fulfillWithValue(owner);
  }
);

const ownerSlice = createSlice({
  name: "owner",
  initialState: {
    owner: {},
  },
  extraReducers: (builder) => {
    builder.addCase(setOwner.fulfilled, (state, action) => {
      return (state = {
        ...state,
        owner: action.payload,
      });
    });
  },
});

export default ownerSlice.reducer;
